import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone'

import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import PhoneIcon from '@mui/icons-material/Phone'
import { Box } from '@mui/material'
import IconInfo from 'components/Bookings/Confirmation/IconInfo'
import React from 'react'

interface Props {
  data: any
}

const StatusOnRoute: React.FC<Props> = (props) => {
  const { data } = props
  const driver = data?.tracking?.driver
  const vehicle = data?.tracking?.driver?.vehicle
  const vehicleDescription = [vehicle?.colour?.toUpperCase(), vehicle?.makeAndModel]
    .filter(Boolean)
    .join(' ')

  const Reply = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <IconInfo
            Icon={AccountCircleTwoToneIcon}
            title="Driver"
            value={driver?.name ?? ''}
          />
          <IconInfo
            Icon={PhoneIcon}
            title="Mobile"
            value={driver?.contactNumber ?? ''}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <IconInfo
            Icon={DirectionsCarIcon}
            title="Vehicle"
            value={vehicleDescription}
          />
        </Box>
      </Box>
    )
  }

  return <Reply />
}

export default StatusOnRoute
